import { Component } from '@angular/core';

@Component({
  selector: 'app-parentapp-student-progress-report',
  templateUrl: './parentapp-student-progress-report.component.html',
  styleUrls: ['./parentapp-student-progress-report.component.scss']
})
export class ParentappStudentProgressReportComponent {

}
